/* nplus-deposit-confirmation.js — <nplus-deposit-confirmation>
   Reads ?payment_intent (from the post-deposit redirect / Stripe return_url), fetches its status
   from the backend (/deposit-status), and renders the summary. Classic script. */
(function () {
  'use strict';

  function endpoint(piId) {
    var isLocal = /^(127\.0\.0\.1|localhost)$/.test(location.hostname);
    var q = '?payment_intent=' + encodeURIComponent(piId);
    if (isLocal && window.__BACKEND_BASE) return window.__BACKEND_BASE.replace(/\/$/, '') + '/deposit-status' + q;
    return '/apps/nplus-deposit/deposit-status' + q;
  }

  function money(minor, currency) {
    var major = (Number(minor) || 0) / 100;
    try {
      return new Intl.NumberFormat(navigator.language || 'en', { style: 'currency', currency: String(currency || 'EUR').toUpperCase() }).format(major);
    } catch (e) {
      return major.toFixed(2) + ' ' + String(currency || '').toUpperCase();
    }
  }

  class NplusDepositConfirmation extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      var cfgEl = this.querySelector('.nplus-dc__config');
      try { this.cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { this.cfg = {}; }
      this.loadingEl = this.querySelector('[data-nplus-dc-loading]');
      this.detailsEl = this.querySelector('[data-nplus-dc-details]');
      this.errorEl = this.querySelector('[data-nplus-dc-error]');
      this.load();
    }

    t(key, fb) { return (this.cfg && this.cfg.i18n && this.cfg.i18n[key]) || fb; }

    param() {
      var p = new URLSearchParams(location.search);
      return p.get('payment_intent') || p.get('pi') || '';
    }

    fail(msg) {
      if (this.loadingEl) this.loadingEl.hidden = true;
      if (this.errorEl) {
        this.errorEl.textContent = msg || this.t('error', 'We could not load your deposit confirmation.');
        this.errorEl.hidden = false;
      }
    }

    load() {
      var self = this;
      var id = this.param();
      if (!/^pi_[A-Za-z0-9]+$/.test(id)) { this.fail(this.t('missing', 'No payment reference found.')); return; }
      fetch(endpoint(id), { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.json(); })
        .then(function (pi) { self.render(pi); })
        .catch(function () { self.fail(); });
    }

    render(pi) {
      var self = this;
      if (this.loadingEl) this.loadingEl.hidden = true;
      function set(sel, val) { var el = self.querySelector(sel); if (el) el.textContent = val; }
      set('[data-nplus-dc-ref]', pi.id || '');
      var statusEl = this.querySelector('[data-nplus-dc-status]');
      if (statusEl) {
        var ok = pi.status === 'succeeded';
        statusEl.textContent = ok ? this.t('status_succeeded', 'Confirmed') : String(pi.status || '').replace(/_/g, ' ');
        statusEl.classList.toggle('is-ok', ok);
      }
      set('[data-nplus-dc-amount]', money(pi.amount, pi.currency));
      // Combined leasing-deposit PIs carry the linked draft order; pure deposits don't.
      if (pi.draftOrderName || pi.draftOrderId) {
        set('[data-nplus-dc-inquiry]', pi.draftOrderName || String(pi.draftOrderId));
        var inquiryRow = this.querySelector('[data-nplus-dc-inquiry-row]');
        if (inquiryRow) inquiryRow.hidden = false;
      }
      if (this.detailsEl) this.detailsEl.hidden = false;
    }
  }

  if (!customElements.get('nplus-deposit-confirmation')) {
    customElements.define('nplus-deposit-confirmation', NplusDepositConfirmation);
  }
})();
